const PAPTOQ_API_BASE = 'https://api.paptoq.com/api/v1';
const PAPTOQ_BIZ_API_BASE = 'https://business-api.paptoq.com/api';

export interface PaptoqApiBases {
  apiBaseUrl: string;
  bizApiBaseUrl: string;
}

// Explicit allow-list: staging stays on petota.dev, so no other paptoq.com host may reach the
// production API, whatever label it carries.
const PAPTOQ_BUSINESS_HOSTS: ReadonlySet<string> = new Set([
  'paptoq.com',
  'www.paptoq.com',
  'business.paptoq.com',
]);

function isPaptoqProductionHost(hostname: string): boolean {
  return PAPTOQ_BUSINESS_HOSTS.has(hostname.toLowerCase());
}

/**
 * First-party API bases for the Paptoq hostnames. Returns undefined everywhere else, so the
 * `VITE_API_BASE_URL` / `VITE_BIZ_API_BASE_URL` build values stay in force on petota.dev,
 * staging and localhost.
 */
export function paptoqApiBases(
  hostname: string | undefined = typeof window === 'undefined' ? undefined : window.location.hostname,
): PaptoqApiBases | undefined {
  if (!hostname || !isPaptoqProductionHost(hostname)) return undefined;
  return { apiBaseUrl: PAPTOQ_API_BASE, bizApiBaseUrl: PAPTOQ_BIZ_API_BASE };
}
